import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useEffect, useState } from "react";
import { useRopV2AppNative } from "../../../ropv2app/context/RopV2AppNativeContext";
import type { PushNotification } from "../../../ropv2app/models/push-notification.model";

type PushNotificationAlarmData = {
  notificationType: "Alarm";
  alarmNotificationId: string;
  alarmUrl: string;
};

type PushNotificationDailyReportData = {
  notificationType: "DailyReport";
  pdfUrl: string;
};

type PushNotificationMonthlyReportData = {
  notificationType: "MonthlyReport";
  pdfUrl: string;
};

type NotificationDialogProps = {
  title?: string;
  body?: string;
  open: boolean;
  setOpen: (open: boolean) => void;
};

function NotificationDialog({
  title,
  body,
  open,
  setOpen,
}: NotificationDialogProps) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="sm">
        {title && <DialogTitle>{title}</DialogTitle>}
        {body && (
          <DialogContent>
            <DialogContentText>{body}</DialogContentText>
          </DialogContent>
        )}
        <DialogActions>
          {/* <Button onClick={handleClose}>ABRIR</Button> */}
          <Button color="error" onClick={handleClose} autoFocus>
            FECHAR
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export function NotificationBackdrop() {
  const { lastNotification, lastOpenedNotification } = useRopV2AppNative();

  const [showBackdrop, setShowBackdrop] = useState(false);
  const [message, setMessage] = useState<{
    title?: string;
    body?: string;
  } | null>(null);

  function showNotification(notification: PushNotification) {
    setMessage({
      title: notification.title || undefined,
      body: notification.body || undefined,
    });

    setShowBackdrop(true);
  }

  function goToLink(url: string) {
    window.location.href = url;
  }

  function handleNotification(notification: PushNotification) {
    const data = notification.data as
      | PushNotificationAlarmData
      | PushNotificationDailyReportData
      | PushNotificationMonthlyReportData
      | null
      | undefined;

    switch (data?.notificationType) {
      case "Alarm":
      case "DailyReport":
      case "MonthlyReport":
        return;
      default:
        // Exibe na tela a notificação quando ela é simples
        // ou com notificationType, mas valor não esperado
        showNotification(notification);
        break;
    }
  }

  function handleOpenedNotificationAction(notification: PushNotification) {
    // Notificação simples, sem data
    if (!notification.data) {
      showNotification(notification);
      return;
    }

    const data = notification.data as
      | PushNotificationAlarmData
      | PushNotificationDailyReportData
      | PushNotificationMonthlyReportData;

    switch (data.notificationType) {
      case "Alarm":
        // XXX: Melhoria, aqui pode-se usar o router para navegar mais rápido
        goToLink(data.alarmUrl);
        break;
      case "DailyReport":
        // XXX: Melhoria, aqui pode-se usar o router para navegar mais rápido
        goToLink(data.pdfUrl);
        break;
      case "MonthlyReport":
        // XXX: Melhoria, aqui pode-se usar o router para navegar mais rápido
        goToLink(data.pdfUrl);
        break;
      default:
        // Notificação com notificationType, mas valor não esperado
        console.warn(
          "handleOpenedNotificationAction: valor de notificationType não esperado:",
          data
        );
        showNotification(notification);
        break;
    }
  }

  useEffect(() => {
    if (!lastNotification) {
      return;
    }

    // Fluxo ao receber uma notificação

    handleNotification(lastNotification);
  }, [lastNotification]);

  useEffect(() => {
    if (!lastOpenedNotification) {
      return;
    }

    // Fluxo ao abrir uma notificação

    handleOpenedNotificationAction(lastOpenedNotification);
  }, [lastOpenedNotification]);

  return (
    <>
      <NotificationDialog
        title={message?.title}
        body={message?.body}
        open={showBackdrop}
        setOpen={setShowBackdrop}
      />
    </>
  );
}

export default NotificationBackdrop;
